import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { SingleselectDropdownComponent } from '@niceltd/cxone-components/singleselect-dropdown';
import { CvConfigurationService } from '../services/cv-configuration.service';
import { FilterTextPipe } from '../pipes/filter-text.pipe';

type CXOneSingleSelectOption = {
    id: string;
    name?: string;
};


@Component({
    selector: 'cv-single-select',
    templateUrl: './single-select.component.html',
    styleUrls: ['./single-select.component.scss']
})
export class SingleSelectComponent implements OnInit, OnChanges {
    @Input() id: string;
    @Input() disabled = false;
    @Input() search = true;
    @Input() placeholder = undefined;
    @Input() value: any;
    @Input() options: any[];
    @Input() autoWidth = false;
    @Input() isLoading = false;
    @Input() primaryKey: string;
    @Input() label: string;
    @Input() selectionText: string;

    @Output() opened = new EventEmitter<void>();
    @Output() closed = new EventEmitter<void>();
    @Output() valueChange = new EventEmitter<any>();

    @ViewChild(SingleselectDropdownComponent) cxOneSingleSelectComponent: SingleselectDropdownComponent;
    @ViewChild(MatSelect) matSelectComponent: MatSelect;

    @ViewChildren(CdkVirtualScrollViewport) cdkVirtualScrollViewPorts: QueryList<CdkVirtualScrollViewport>;

    filterText = '';
    cxValue: CXOneSingleSelectOption;
    cxOptions: CXOneSingleSelectOption[];

    constructor(
        public config: CvConfigurationService,
        private filterTextPipe : FilterTextPipe
    ) { }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        let hasSetupValues = false;
        if (changes.options?.currentValue) {
            this.cxOptions = this.options.map(option => ({
                id: option[this.primaryKey],
                name: option[this.label],
            }));

            if (this.value != null) {
                this.setupCxOneSelection();
                hasSetupValues = true;
            }
        }

        if (!hasSetupValues && changes.value?.currentValue != null) {
            if (this.cxOptions?.length) {
                this.setupCxOneSelection();
            }
        }
    }

    closeDropdown() {
        if (this.config.isCxOne) {
            if (this.cxOneSingleSelectComponent?.isDropdownOpen)
                this.cxOneSingleSelectComponent.toggleDropdown();
        } else {
            this.matSelectComponent?.close();
        }
    }

    setupCxOneSelection() {
        this.cxValue = this.cxOptions.find(o => o.id === this.value);
    }

    onOpen() {
        // virtual scroll won't render properly without triggering a scroll to the top
        this.cdkVirtualScrollViewPorts?.forEach(viewport => {
            viewport.scrollToIndex(1);
            viewport.scrollToIndex(0);
            viewport.checkViewportSize();
        });

        this.opened.emit();
    }

    onClose() {
        const filteredOptions = this.filterTextPipe.transform(this.options, this.filterText, this.label);
        if (filteredOptions.length === 0) this.filterText = '';
        this.closed.emit();
    }

    onMatSelectChange(change: MatOptionSelectionChange) {
        if (!change.isUserInput)
            return;

        const id: number = change.source.value;
        this.value = id;
        this.valueChange.emit(this.value);
    }

    onCxOneOpen() {
        this.opened.emit();
    }

    onCxOneClose() {
        this.closed.emit();
    }

    onCxOneSelectChange(change: { selected: CXOneSingleSelectOption }) {
        this.value = change.selected.id;
        this.valueChange.emit(this.value);
    }
}
